import { useGetCorePatients } from 'infrastructure/hooks/patient/use-get-core-patients';
import { generateFullName } from 'utils/badgeHelpers';
import { CcmStatuses, ClinicStatus } from 'infrastructure/enums';

import type { TQueryProps } from 'infrastructure/hooks/patient/use-get-core-patients';
import type {
  ICorePatientsResponse,
  ICcmOnboardingStatusReportFilters,
} from 'infrastructure/interfaces';

export const defaultCcmStatuses = [
  CcmStatuses.CCMReferralReceived,
  CcmStatuses.CCMReferralOnHold,
  CcmStatuses.CCMReferralWithdrawn,
  CcmStatuses.CCMPatientNoContact,
  CcmStatuses.CCMCallingQueue,
  CcmStatuses.CCMPatientRefusedCoPayInsurance,
  CcmStatuses.CCMPatientRefusedExpired,
  CcmStatuses.CCMPatientRefusedChangedDoctor,
  CcmStatuses.CCMPatientRefusedNotInterestedNotNecessarySuspectScam,
  CcmStatuses.CCMPatientRefusedWrongContactInformation,
  CcmStatuses.CCMPatientRefusedNoContact,
  CcmStatuses.CCMPatientRefusedOther,
  CcmStatuses.CCMOnboarding,
  CcmStatuses.CCMOnboardingUnsuccessfulNoContact,
  CcmStatuses.CCMOnboardingUnsuccessfulPatientRefused,
  CcmStatuses.CCMOnboardingUnsuccessfulPatientNotQualifiedForCCM,
  CcmStatuses.CCMOnboardingUnsuccessfulChangedDoctor,
  CcmStatuses.CCMOnboardingUnsuccessfulOther,
];

const clinicStatus = [ClinicStatus.Active, ClinicStatus.Delinquent];

const prepareData = (data?: ICorePatientsResponse) => {
  return {
    patients: data?.items?.map((item) => ({
      ...item,
      name: `${item.firstName} ${item.lastName}`,
      dob: item.birthDate,
      insType: item.insurances.length ? item.insurances[0].type : null,
      primaryDoctor:
        item.primaryDoctor &&
        generateFullName(
          item.primaryDoctor.title,
          item.primaryDoctor.firstName,
          null,
          item.primaryDoctor.lastName,
        ),
      insProvider: item.insurances.length
        ? item.insurances.map((insurance) => insurance.provider).join(',\n')
        : null,
      insNumber: item.insurances.length
        ? item.insurances.map((insurance) => insurance.number).join(',\n')
        : null,
      practiceEmail: item.primaryDoctor.email,
    })),
    patientCount: data?.count,
  };
};

export const useOnboardingStatusReport = ({
  patientGuid,
  ccmStatuses,
  ...props
}: ICcmOnboardingStatusReportFilters) => {
  const filter: TQueryProps = {
    ...props,
    clinicGuid: props.clinicGuid?.join(','),
    ccmStatus: ccmStatuses.length
      ? ccmStatuses.join(',')
      : defaultCcmStatuses.join(','),
    clinicsStatus: clinicStatus.join(','),
    status: 'all',
    guid: patientGuid,
  };

  const { data, isLoading, isFetching } = useGetCorePatients(filter);

  return {
    patients: prepareData(data),
    patientsLoading: isLoading || isFetching,
  };
};
